import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["metadataId", "templateActions", "templatePagePath", "className", "title", "description", "position", "templateImage", "onMouseEnter", "previewButton", "actionButtonProps", "accessConstraints", "appSlug", "tags", "metadataId", "newBoardMetadataId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import { Box, Text, useWindowSize, Portal, Desktop } from '@miro-site/core';
import styled, { useTheme } from 'styled-components';
import CardDescription from './components/CardDescription';
import CardImage from './components/CardImage';
import ActionsOverlay from './components/ActionsOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ImageContainer = styled(Box).withConfig({
  displayName: "TemplateCard__ImageContainer",
  componentId: "sc-jfbzgc-0"
})(["position:relative;"]);

var TemplateCard = function TemplateCard(_ref) {
  var metadataId = _ref.metadataId,
      templateActions = _ref.templateActions,
      templatePagePath = _ref.templatePagePath,
      className = _ref.className,
      title = _ref.title,
      description = _ref.description,
      position = _ref.position,
      templateImage = _ref.templateImage,
      onMouseEnter = _ref.onMouseEnter,
      previewButton = _ref.previewButton,
      actionButtonProps = _ref.actionButtonProps,
      accessConstraints = _ref.accessConstraints,
      appSlug = _ref.appSlug,
      tags = _ref.tags,
      _metadataId = _ref.metadataId,
      _newBoardMetadataId = _ref.newBoardMetadataId,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      showDescription = _useState[0],
      setShowDescription = _useState[1];

  var theme = useTheme();
  var windowSize = useWindowSize();
  var isMobileViewPort = windowSize.width && windowSize.width < theme.breakpoints.small;

  var _useState2 = useState(false),
      isOverlayVisible = _useState2[0],
      setOverlayVisible = _useState2[1];

  var getContainerHandlers = function getContainerHandlers() {
    if (isMobileViewPort) {
      return {
        onClick: function onClick() {
          setOverlayVisible(true);
        }
      };
    }

    return {
      onMouseEnter: function onMouseEnter() {
        return setOverlayVisible(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setOverlayVisible(false);
      }
    };
  };

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    className: className
  }, props), {}, {
    onMouseEnter: onMouseEnter,
    children: [/*#__PURE__*/_jsxs(ImageContainer, _objectSpread(_objectSpread({}, getContainerHandlers()), {}, {
      children: [/*#__PURE__*/_jsx(CardImage, {
        onShowCardDescription: function onShowCardDescription() {
          return setShowDescription(true);
        },
        image: _objectSpread(_objectSpread({}, templateImage), {}, {
          width: 360,
          height: 232
        }),
        priority: position === 0,
        wrapperStyles: {
          marginBottom: [12, 16],
          borderRadius: [8, 16],
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          height: 0,
          paddingTop: ['100%', '64.444%'],
          background: 'grey'
        }
      }), /*#__PURE__*/_jsx(Desktop, {
        $block: true,
        children: /*#__PURE__*/_jsx(ActionsOverlay, {
          metadataId: metadataId,
          templateActions: templateActions,
          templatePagePath: templatePagePath,
          previewButton: previewButton,
          actionButtonProps: actionButtonProps,
          onMoreInfoClick: function onMoreInfoClick() {
            return setShowDescription(true);
          },
          isVisible: isOverlayVisible
        })
      }), isMobileViewPort ? /*#__PURE__*/_jsx(Portal, {
        children: /*#__PURE__*/_jsx(CardDescription, {
          metadataId: metadataId,
          templateActions: templateActions,
          templatePagePath: templatePagePath,
          isShown: showDescription,
          isFullscreen: true,
          previewButton: previewButton,
          actionButtonProps: actionButtonProps,
          title: title,
          tags: tags,
          description: description,
          thumbnail: templateImage,
          onClose: function onClose() {
            return setShowDescription(false);
          },
          popupStyles: {
            position: 'fixed',
            top: 0,
            right: 0,
            left: 0,
            height: '100%',
            overflow: 'auto',
            zIndex: 701,
            paddingTop: [64, null],
            paddingRight: [20, null],
            paddingBottom: [43, null],
            paddingLeft: [20, null]
          }
        })
      }) : /*#__PURE__*/_jsx(CardDescription, {
        metadataId: metadataId,
        templateActions: templateActions,
        templatePagePath: templatePagePath,
        isShown: showDescription,
        previewButton: previewButton,
        actionButtonProps: actionButtonProps,
        title: title,
        tags: tags,
        description: description,
        thumbnail: templateImage,
        onClose: function onClose() {
          return setShowDescription(false);
        },
        popupStyles: {
          position: 'absolute',
          overflow: 'hidden',
          width: '100%',
          minHeight: '100%',
          paddingTop: [null, 28],
          paddingRight: [null, 28],
          paddingBottom: [null, 28],
          paddingLeft: [null, 28],
          top: 0,
          left: 0
        }
      })]
    })), /*#__PURE__*/_jsx(Text, {
      as: "div",
      $styles: {
        fontSize: [14, 18],
        lineHeight: [18, 24],
        fontWeight: 700
      },
      children: title
    })]
  }));
};

export default TemplateCard;